import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { DataGrid, gridClasses, GridColDef } from '@mui/x-data-grid';
import { localDateAndTimeFormat } from '../../../../utils/timeFormat';
import { isDefaultDate } from '../../../../utils/common';
import { useState } from 'react';

const MatchedHistoryModal = (props) => {
    const { handleClose, open, matchedHistory } = props;
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });

    const columns: GridColDef[] = [
        {
            field: 'MatchedDate',
            headerName: 'Matched Date',
            flex: 1,
            valueGetter: (value, row) => `${isDefaultDate(row.MatchedDate) ? '' : localDateAndTimeFormat(new Date(row.MatchedDate))}`,
        },
        {
            field: 'ProviderName',
            headerName: 'Provider',
            flex: 1,
        },
        {
            field: 'Status',
            headerName: 'Status',
            flex: 1,
        },
    ];
    return (
        <Dialog onClose={handleClose} open={open} sx={{ padding: 5 }} maxWidth="lg" fullWidth>
            <DialogTitle>Alert History</DialogTitle>
            <div style={{ width: '100%', height: '80vh', overflowY: 'scroll' }}>
                <DataGrid
                    rows={matchedHistory}
                    columns={columns}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[5]}
                    getRowId={(row) => Math.random()}
                    sx={{
                        [`& .${gridClasses.cell}`]: {
                            py: 1,
                        },
                    }}
                />
            </div>
            <DialogActions>
                <Button className="button-120" variant="outlined" onClick={handleClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default MatchedHistoryModal;
